<app-general-header></app-general-header>

<header>Confirm Subscription</header>
<div class="container">
  <div class="confirmation-container">
    @if (!isUserSubscribed) {
      <p>
        Please Confirm Your Subscription to the BrainKey Blog
      </p>
      <button class="button button-primary" (click)="confirmSubscription()">
        Yes, subscribe me!
      </button>
      @if (error !== null) {
        <div @fadeIn class="subscription-error">{{ error }}</div>
      }
    } @else {
      <p @fadeIn>
        Thank you for subscribing to the BrainKey Blog. Your subscription has been confirmed.
      </p>
    }

  </div>
</div>
<app-explore-your-brain></app-explore-your-brain>
<app-footer></app-footer>
